<script setup>
const router = useRouter()
router.push('/sign-in')
</script>

<template>
  <div />
</template>
